import { createApp } from "vue";
import App from "./App.vue";
import { router } from "./router";
import { fontAwesome, bootstrap } from "./libs";

createApp(App).use(router).use(fontAwesome).use(bootstrap).mount("#app");
